import Head from 'next/head';
import {useRouter} from 'next/router';
import {FC} from 'react';
import qs from 'qs';
import {NEXT_PUBLIC_MASTER_HOST} from 'core/helpers/env';
import {PAGINATION_PARAM} from 'core/constants';
import {metaData, ORG_JSON_LD} from 'core/modules/PageHead/constants';
import {FILTER_URL_SLUG} from 'plugins/modules/filter/constants';

interface IProps {
    title?: string;
    description?: string;
    robots?: string;
    keywords?: string;
    imageUrl?: string;
    ogUrl?: string;
}

// eslint-disable-next-line complexity
export const PageHead: FC<IProps> = ({
    title = metaData.home.title,
    description = metaData.home.description,
    robots,
    ogUrl,
    imageUrl,
    keywords,
}) => {
    const {asPath} = useRouter();
    const path = ('/' === asPath ? '' : asPath).split('?')[0];
    const url = NEXT_PUBLIC_MASTER_HOST + path;

    // механизм позволяющий отключать роботов для различных кейсов
    let resolvedRobots = robots ?? 'index, follow';

    // страница детальной акции с применёнными боковыми фильтрами с filter должны быть noindex.
    const isStockFilterPath = path.startsWith('/stock/') && path.includes(FILTER_URL_SLUG);

    if (isStockFilterPath) {
        resolvedRobots = 'noindex';
    }

    const hasQuery = asPath.includes('?');

    if (hasQuery) {
        const queryString = asPath.split('?')[1] || '';
        const queryStringBeforeHash = queryString.split('#')[0];
        const parsedQueryString = qs.parse(queryStringBeforeHash);
        const params = Object.keys(parsedQueryString);

        if (1 === params.length && PAGINATION_PARAM === params[0]) {
            resolvedRobots = 'noindex, follow';
        } else {
            resolvedRobots = 'noindex';
        }
    }

    return (
        <Head>
            <meta name={'robots'} content={resolvedRobots} key={'robots'} />
            <meta name={'description'} content={description || metaData.home.description} key={'description'} />
            <meta property={'og:title'} content={title || metaData.home.title} key={'ogTitle'} />
            <meta property={'og:type'} content={'website'} key={'ogType'} />
            <meta
                property={'og:description'}
                content={description || metaData.home.description}
                key={'ogDescription'}
            />
            <meta property={'og:site_name'} content={ORG_JSON_LD.name} key={'ogStimeName'} />

            {keywords && <meta name={'keywords'} content={keywords} />}
            {imageUrl && <meta property={'og:image'} content={imageUrl} key={'imageUrl'} />}
            <meta property={'og:url'} content={ogUrl || url} key={'ogUrl'} />

            <link href={url} key={'canonical'} rel={'canonical'} />
            <title>{title || metaData.home.title}</title>
        </Head>
    );
};
